import * as z from "zod";

import { issueWithCreatedBySchema } from "./issue-with-created-by";
import { issueWithLinksSchema } from "./issue-with-links";

export const issueWithCreatedByAndLinksSchema = issueWithCreatedBySchema.extend(
  issueWithLinksSchema.shape,
);

export type IssueWithCreatedByAndLinks = z.infer<
  typeof issueWithCreatedByAndLinksSchema
>;
